import { Box, Heading as ChakraHeading, Text, Link as ChakraLink } from '@chakra-ui/react'
import Link from 'next/link'
import { routes } from 'routes'

type EntityType = 'job' | 'undefined'
type StatusCode = 404 | 500

type Props = { type: EntityType; statusCode: StatusCode }

const Heading = ({ type, statusCode }: Props) => {
    const text = (() => {
        if (statusCode === 500) {
            return 'Sorry! Something went wrong.'
        }
        switch (type) {
            case 'job':
                return 'Sorry! That job is either no longer live or never existed.'
            default:
                return "Sorry! This page doesn't exist"
        }
    })()

    return (
        <ChakraHeading as="h1" size="md" mb="12px">
            {text}
        </ChakraHeading>
    )
}

const Body = ({ type, statusCode }: Props) => {
    const text = (() => {
        if (statusCode === 500) {
            return 'Try to refresh this page or feel free to contact us if the problem persists.'
        }
        switch (type) {
            case 'job':
                return (
                    <>
                        If you think this might be a mistake, double check the link,
                        otherwise browse the available jobs on our{' '}
                        <Link href={routes.jobs()} passHref>
                            <ChakraLink
                                color="primary.500"
                                fontWeight={{ base: '500', xl: '600' }}
                                fontSize="inherit"
                                textDecoration="underline"
                            >
                                job board.
                            </ChakraLink>
                        </Link>
                    </>
                )
            default:
                return <>Please try again later.</>
        }
    })()

    return <Text variant="bodyTextSmall">{text}</Text>
}

export const CustomError = ({ type, statusCode }: Props) => {
    return (
        <Box
            mx={{
                base: '16px',
                sm: '24px',
                md: '32px',
                lg: '0',
            }}
            my={{ base: '16px', sm: '24px', md: '32px', lg: '48px', xl: '64px' }}
            minH="100vh"
        >
            <Heading type={type} statusCode={statusCode} />
            <Body type={type} statusCode={statusCode} />
        </Box>
    )
}
